import { defineSlotRecipe } from '@chakra-ui/react';

export const cardRecipe = defineSlotRecipe({
	slots: ['root', 'container', 'body', 'header', 'footer'],
	base: {
		root: {
			borderRadius: '1.25rem',
		},
		body: {
			padding: { base: '1.125rem', mobile: '1.5rem' },
		},
		header: {
			padding: { base: '1.125rem', mobile: '1.5rem' },
			paddingBottom: 0,
		},
		footer: {
			padding: { base: '1.125rem', mobile: '1.5rem' },
			paddingTop: 0,
		},
	},
	variants: {
		variant: {
			elevated: {
				root: {
					bg: 'rgba(251, 249, 255, 1)',
					boxShadow: 'md',
				},
			},
			outline: {
				root: {
					bg: 'rgba(251, 249, 255, 1)',
					borderWidth: '1px',
					borderColor: 'border',
				},
			},
			subtle: {
				root: {
					bg: 'rgba(251, 249, 255, 1)',
				},
			},
		},
	},
	defaultVariants: {
		variant: 'subtle',
	},
});
